import { Map, fromJS } from 'immutable';

import { mapListToMaps } from '@sophocles/entities/entityUtils';
import apiClient from '@sophocles/http-common';
import {
  checkHttpStatus,
  dataTableParamFormatter,
  errorActionWithAlert,
  genericErrorAction,
  mapToQueryParams,
} from '@sophocles/utils';

/* RECEIVE ACTIONS */
export const RECEIVE_USERS = 'RECEIVE_USERS';
export function receiveUsers(json) {
  return {
    type: RECEIVE_USERS,
    users: mapListToMaps(json),
  };
}

// effectively the same as RECEIVE_USERS, leaving for legacy purposes.
export const RECEIVE_LIMITED_USERS = 'RECEIVE_LIMITED_USERS';
export function receiveLimitedUsers(json) {
  return {
    type: RECEIVE_LIMITED_USERS,
    users: mapListToMaps(json),
  };
}

export const REQUEST_ALL_USERS = 'REQUEST_ALL_USERS';
function requestAllUsers() {
  return {
    type: REQUEST_ALL_USERS,
  };
}

export const REQUEST_USER = 'REQUEST_USER';

function requestUser(user) {
  return {
    type: REQUEST_USER,
    user,
  };
}

/* FETCH ACTIONS */
export function fetchAllUsers(filterObject) {
  return tableParams => dispatch => {
    dispatch(requestAllUsers());
    const params = Map(filterObject).merge(dataTableParamFormatter(tableParams));
    return (
      apiClient
        .get(`/users/?${mapToQueryParams(params)}`)
        .then(response => fromJS(response.data))
        // .then( json => dispatch(receiveLimitedUsers(json.entities.users)))
        .catch(error => dispatch(genericErrorAction(error, REQUEST_ALL_USERS)))
    );
  };
}

export function fetchUsersForList(offset, limit, myFilters, search) {
  return dispatch => {
    const params = Map(myFilters);
    return apiClient
      .get(
        `/users/?text_search=first_name%2Clast_name%2Cid%2Cemail%7C${search}&offset=${offset}&limit=${limit}&${mapToQueryParams(
          params,
        )}`,
      )
      .then(checkHttpStatus)
      .then(response => fromJS(response.data))
      .catch(error => dispatch(genericErrorAction(error, 'REQUEST_SITES_FOR_LIST')));
  };
}

export function fetchAllSalesUsers() {
  return dispatch => {
    dispatch(requestAllUsers());
    return apiClient
      .get(`/users/?groups=5&is_active=True&limit=10000`)
      .then(response => response.data.results)
      .catch(error => dispatch(genericErrorAction(error, REQUEST_ALL_USERS)));
  };
}

export function fetchAllUserSellers() {
  return dispatch => {
    dispatch(requestAllUsers());
    return apiClient
      .get(`/users/?groups=1072&limit=10000`)
      .then(response => response.data.results)
      .catch(error => dispatch(genericErrorAction(error, REQUEST_ALL_USERS)));
  };
}

export function fetchUsersForCustomerAndSiteGroup(customerId, siteGroupId) {
  return dispatch =>
    apiClient
      .get(`/users/?customer=${customerId}&id__gt=0&is_active=True&o=first_name&site_group=${siteGroupId}&limit=10000`)
      .then(response => response.data.results)
      .catch(error => dispatch(genericErrorAction(error, REQUEST_ALL_USERS)));
}

export function fetchEligibleSiteGroupsForCustomer(customer) {
  return dispatch =>
    apiClient
      .get(`/usersitegroups/eligiblesitegroups/?customer=${customer}&limit=10000`)
      .then(checkHttpStatus)
      .then(response => fromJS(response.data.results))
      .catch(error => dispatch(errorActionWithAlert(error, 'FETCH_ELIGIBLE_SITE_GROUPS')));
}

export function fetchEligibleUserGroups(user) {
  return dispatch =>
    apiClient
      .get(`/users/${user}/eligibleusergroups/?limit=10000`)
      .then(checkHttpStatus)
      .then(response => response.data)
      .catch(error => dispatch(genericErrorAction(error, 'FETCH_ELIGIBLE_USER_GROUPS')));
}
